<template>
  <div class="swiper-slide" data-swiper-autoplay="5000">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name:'VSwiperSlide'
};
</script>

<style>
</style>